export const MotionStatusRing = ({ pct = 0, size = 148, children }) => {
  const clamped = Math.min(100, Math.max(0, pct));
  const angle = clamped * 3.6;
  return (
    <div
      className="rounded-full p-[7px] shadow-[0_0_50px_rgba(34,211,238,0.14)] transition-[background] duration-700"
      style={{
        width: size,
        height: size,
        background: `conic-gradient(#22D3EE 0deg, #2DD4BF ${angle}deg, rgba(255,255,255,0.08) ${angle}deg)`,
      }}
    >
      <div className="w-full h-full rounded-full bg-[#0A101D] flex flex-col items-center justify-center text-center">
        {children}
      </div>
    </div>
  );
};
